const T = require("react").PropTypes;

const AuditType = require("./AuditType.js").PropType;
const DistrictType = require("./District.js").PropType;
const DivisionType = require("./Division.js").PropType;
const ErrorType = require("./Error.js").PropType;
const CompletionCountType = require("./CompletionCount.js").PropType;

const Reports = {
    PropType: T.shape({
        SelectedAudit: T.string, 
        SelectedDivision: DivisionType,
        SelectedDistrict: DistrictType,
        DateRange: T.string, 
        CompletedAudits: T.shape({
            Data: T.arrayOf(CompletionCountType),
            Loading: T.bool,
            Error: ErrorType
        })
    })
};

module.exports = Reports;


// WEBPACK FOOTER //
// ./src/types/Reports.js